export enum AppEnvs {
  DEV = 'dev',
  QA = 'qa',
  SANDBOX = 'sandbox',
  PROD = 'prod',
}

export type Envs = {
  readonly REACT_APP_API_URL: string
  readonly REACT_APP_GRAPHQL_SCHEMA_URL: string
  readonly REACT_APP_GRAPHQL_SCHEMA_ORIGIN: string
  readonly REACT_APP_IMAGEKIT_URL: string
  readonly REACT_APP_CLOUDFRONT_CDN_URL?: string
  readonly REACT_APP_AWS_REGION: string
  readonly REACT_APP_AWS_USER_POOL_ID: string
  readonly REACT_APP_AWS_CLIENT_ID: string
  readonly REACT_APP_NEXT_APP_ORIGIN: string
  readonly REACT_APP_ENV: AppEnvs

  readonly REACT_APP_SENTRY_DSN: string
  readonly REACT_APP_SENTRY_ENVIRONMENT: string
  readonly REACT_APP_SENTRY_RELEASE: string
  readonly SENTRY_AUTH_TOKEN: string
  readonly SENTRY_ORG: string
  readonly SENTRY_PROJECT: string
}
